import { AppConfig } from "@/lib/nemmp/app-config";

export const MLogo = ({ appConfig }: { appConfig: AppConfig }) => {
  return <img src="/assets/logo.svg" alt={appConfig.name} width="150" />;
};
